// Modules
import React from 'react'
import { Switch } from 'react-router-dom'

// Components
import { ContainerProvider, FullPageLoading, RedirectSingleSpa } from 'components'
import { ROUTES_PATH } from 'constants/routesPath'
import ExternalCompany from 'hooks/useExternalCompany'
import {
    ACOCPF,
    ActivateAccount,
    CheckPartner,
    DeepLink,
    Login,
    LoginAuto,
    LoginWithOtp,
    Logout,
    MDMCIPCreatePassword,
    MDMCIPSelectContact,
    MDMCIPValidateToken,
    MDMCreatePassword,
    MDMSelectContact,
    MDMValidateToken,
    NEWCIPBiologicalSex,
    NEWCIPCreatePassword,
    NEWCIPPhone,
    NEWCIPValidateToken,
    RecoverPassword,
    RedirectPage,
    RegisterExames,
    RegisterExamesActivateCipOrphan,
    SNCreatePassword,
    SNHomeRedirect,
    SNPersonalData,
    SNPhone,
    SNSelectContact,
    SNValidateToken,
    SelectLaboratory,
    UniqueAccess,
    UpdateContactsUnico,
    FaceBiometricsScreen,
    LoginWithLink,
} from 'pages'
import { LoginSelfService, PhasedLoginStepper } from 'redesign/pages'
import { Router } from './Router'
import { FullError } from 'redesign/pages/FullError'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'
import ExternalLogin from 'pages/ExternalLogin'
import { TemplateSelfService } from 'redesign/components/templates'
import { useInitializeCustomLayout } from 'redesign/hooks/useInitializeCustomLayout'
import { PartnerToken } from 'pages/PartnerToken'

const Routes = () => {
    const { loading } = useRemoteConfig()
    useInitializeCustomLayout()

    return (
        <ContainerProvider>
            {loading ? (
                <FullPageLoading />
            ) : (
                <Switch>
                    {/* DeepLink */}
                    <Router component={DeepLink} exact path={ROUTES_PATH.ONLINE_APPOINTMENT} />
                    {/* Login */}
                    <Router component={Login} exact path={ROUTES_PATH.LOGIN} restricted />
                    <Router component={LoginAuto} exact path={ROUTES_PATH.LOGIN_AUTO} />
                    <Router component={UniqueAccess} exact path={ROUTES_PATH.UNIQUE_ACCESS} />
                    <Router component={SelectLaboratory} exact path={ROUTES_PATH.LOGIN_SELECT_LABORATORY} restricted />
                    <Router component={RegisterExames} exact path={ROUTES_PATH.LOGIN_ACTIVATION_REGISTRATION_EXAMS} />
                    <Router component={PhasedLoginStepper} exact path={ROUTES_PATH.SIGN_IN} restricted />
                    <Router component={FullError} exact path={ROUTES_PATH.LOGIN_CIP_ERROR} restricted />

                    {/* Login with link */}
                    <Router component={LoginWithLink} exact path={ROUTES_PATH.SIGN_IN_WITH_LINK} restricted />

                    {/* Login with OTP */}
                    <Router component={LoginWithOtp} exact path={ROUTES_PATH.LOGIN_WITH_OTP} />

                    {/* Unico */}
                    <Router component={UpdateContactsUnico} exact path={ROUTES_PATH.UPDATE_CONTACTS} />

                    <Router component={FaceBiometricsScreen} exact path={ROUTES_PATH.FACE_BIOMETRICS_SCREEN} />

                    {/* Auto Atendimento */}
                    <Router
                        component={LoginSelfService}
                        exact
                        path={ROUTES_PATH.SIGN_IN_SELF_SERVICE}
                        template={TemplateSelfService}
                    />

                    {/* Recover Password */}
                    <Router component={RecoverPassword} exact path={ROUTES_PATH.RECOVER_PASSWORD_STEP} />
                    <Router component={ActivateAccount} exact path={ROUTES_PATH.RECOVER_PASSWORD_ACTIVATE_ACCOUNT} />
                    {/* Signup */}
                    <Router component={SNHomeRedirect} exact path={ROUTES_PATH.SIGN_UP_HOME_REDIRECT} restricted />
                    <Router component={SNPersonalData} exact path={ROUTES_PATH.SIGN_UP_PERSONAL_DATA} restricted />
                    <Router component={SNCreatePassword} exact path={ROUTES_PATH.SIGN_UP_CREATE_PASSWORD} restricted />
                    <Router component={SNPhone} exact path={ROUTES_PATH.SIGN_UP_PHONE} restricted />
                    <Router component={SNValidateToken} exact path={ROUTES_PATH.SIGN_UP_VALIDATE_TOKEN} restricted />
                    <Router component={SNSelectContact} exact path={ROUTES_PATH.SIGN_UP_SELECT_CONTACT} restricted />
                    <Router component={ActivateAccount} exact path={ROUTES_PATH.SIGN_UP_REGISTRE_ACTIVATE_ACCOUNT} />
                    {/* Account MDM */}
                    <Router component={MDMCreatePassword} exact path={ROUTES_PATH.SIGN_UP_MDM_CREATE_PASSWORD} />
                    <Router component={MDMSelectContact} exact path={ROUTES_PATH.SIGN_UP_MDM_SELECT_CONTACT} />
                    <Router component={MDMValidateToken} exact path={ROUTES_PATH.SIGN_UP_MDM_VALIDATE_TOKEN} />
                    {/* Account CIP Orphan */}
                    <Router component={ACOCPF} exact path={ROUTES_PATH.SIGN_UP_REGISTER_ACTIVATION_CPF} />
                    <Router component={NEWCIPBiologicalSex} exact path={ROUTES_PATH.SIGN_UP_NEW_CIP_BIOLOGICAL_SEX} />
                    <Router component={NEWCIPCreatePassword} exact path={ROUTES_PATH.SIGN_UP_NEW_CIP_CREATE_PASSWORD} />
                    <Router component={NEWCIPPhone} exact path={ROUTES_PATH.SIGN_UP_NEW_CIP_PHONE} />
                    <Router component={NEWCIPValidateToken} exact path={ROUTES_PATH.SIGN_UP_NEW_CIP_VALIDATE_TOKEN} />
                    <Router component={MDMCIPCreatePassword} exact path={ROUTES_PATH.SIGN_UP_MDM_CIP_CREATE_PASSWORD} />
                    <Router component={MDMCIPSelectContact} exact path={ROUTES_PATH.SIGN_UP_MDM_CIP_SELECT_CONTACT} />
                    <Router component={MDMCIPValidateToken} exact path={ROUTES_PATH.SIGN_UP_MDM_CIP_VALIDATE_TOKEN} />
                    <Router
                        component={RegisterExamesActivateCipOrphan}
                        exact
                        path={ROUTES_PATH.SIGN_UP_REGISTER_EXAMS_ACTIVATE_CIP_ORPHAN}
                    />
                    <Router
                        component={RegisterExamesActivateCipOrphan}
                        exact
                        path={ROUTES_PATH.SIGN_UP_REGISTER_EXAMS_ACTIVATE_NEW_CIP_ORPHAN}
                    />
                    {/* External Company */}
                    <Router component={ExternalLogin} exact path={ROUTES_PATH.EXTERNAL_LOGIN} />
                    <Router component={ExternalCompany} exact path={ROUTES_PATH.EXTERNAL_COMPANY} />
                    <Router component={CheckPartner} exact path={ROUTES_PATH.LOGIN_CHECK_PARTNER} />
                    <Router component={PartnerToken} exact path={ROUTES_PATH.PARTNERS_TOKEN} />
                    {/* Redirect */}
                    <Router component={RedirectPage} exact path={ROUTES_PATH.REDIRECT_PAGE} />
                    {/* Logout */}
                    <Router component={Logout} exact path={ROUTES_PATH.LOGOUT} />
                    {/* Others */}
                    <RedirectSingleSpa to={ROUTES_PATH.REDIRECT_PAGE_NOT_FOUND} />
                </Switch>
            )}
        </ContainerProvider>
    )
}

export default Routes
